// Simple SHA-256 implementation compatible with Node.js crypto
async function sha256(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

// Secure hash function for card IDs using Web Crypto API
export const hashCardId = async cardId => {
  if (!cardId || cardId.length === 0) return '0';

  // Create SHA-256 hash using the same method as Node.js crypto
  const hashHex = await sha256(cardId);

  // Return first 16 characters for shorter key (same as backend)
  return hashHex.substring(0, 16);
};
